import { useMemo } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { useStudentMe } from '../../roster/hooks/useStudentMe';
import {
  isTutorQueryIdentityReady,
  resolveRosterStudentId,
  resolveTutorQueryIdentity,
} from '../utils/tutorQueryIdentity';

/** Membership + student keys for tutor TanStack Query caches. */
export function useTutorQueryIdentity() {
  const { user } = useAuth();
  const { student } = useStudentMe();

  return useMemo(() => {
    const studentId = resolveRosterStudentId(student);
    const tenantId =
      user?.memberships?.[0]?.school_id ||
      (typeof localStorage !== 'undefined' ? localStorage.getItem('X_TENANT_ID') : null);
    const identity = resolveTutorQueryIdentity({ studentId, tenantId });
    return {
      ...identity,
      identityReady: isTutorQueryIdentityReady(identity.membershipKey, identity.studentKey),
    };
  }, [student, user?.memberships]);
}
